/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import LiveBlogEntry from './liveblog-entry';
import refresh from './liveblog-social';

const PAGE_SIZE = 15;
const replacerRegex = /^\s*@@([a-zA-Z0-9]+)\s*(.+)$/;

export default class LiveBlog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      entries: [],
      minTime: '',
      more: false,
      lastFetch: null,
      fetchError: null,
    };
    this.last = '';
    this.handleMore = this.handleMore.bind(this);

    this.mainStageState = '';
    this.mainStageTimestamp = '';
  }

  componentDidMount() {
    const { apiEndpoint, pollInterval } = this.props;
    const poll = () => {
      fetch(`${apiEndpoint}?last=${this.last}`, { cache: 'no-store' })
        .then((response) => {
          if (pollInterval !== 0) {
            setTimeout(poll, pollInterval);
          }
          this.setState({ lastFetch: new Date() });
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          }
          throw new Error(response.statusText);
        })
        .then((data) => {
          const newEntries = data.entries;
          if (newEntries && newEntries.length > 0) {
            const { entries, minTime, more } = this.state;

            // Process replacer patterns
            newEntries.forEach((entry, i) => {
              if (entry.message) {
                const matches = entry.message.match(replacerRegex);
                if (matches) {
                  // eslint-disable-next-line prefer-destructuring
                  newEntries[i].message = matches[2];
                  $(`[data-replacer=${matches[1]}]`).html(entry.data);
                  newEntries[i].data = '';
                }
              }
            });

            // Process main-stage entries
            let mainStageUpdate = false;
            newEntries.filter(entry => entry.type === 'stage-main')
              .forEach((entry) => {
                if (entry.timestamp > this.mainStageTimestamp) {
                  this.mainStageTimestamp = entry.timestamp;
                  if (entry.data !== this.mainStageState) {
                    this.mainStageState = entry.data;
                    mainStageUpdate = true;
                  }
                }
              });

            if (mainStageUpdate) {
              try {
                if (this.mainStageState && this.mainStageState.trim().length > 0) {
                  window.IDM314.mainStage.show(this.mainStageState);
                } else {
                  window.IDM314.mainStage.hide();
                }
              } catch (err) {
                console.error('Error updating main stage');
                console.error(err);
              }
            }

            // Update the with the new entries
            this.setState({
              entries: newEntries.concat(entries),
              minTime: entries.length === 0
                ? newEntries.slice(0, PAGE_SIZE).slice(-1)[0].timestamp
                : minTime,
              more: entries.length === 0 ? newEntries.length > PAGE_SIZE : more,
              fetchError: null,
            });
            // Set the last seen timestamp
            this.last = newEntries.reduce((max, entry) => (max > entry.timestamp ? max : entry.timestamp), '');
          }
        })
        .catch((err) => {
          this.setState({ fetchError: `Error fetching updates (${err.message}). This is probably a temporary error.` });
          console.error(err);
        });
    };

    poll();
  }

  componentDidUpdate() {
    refresh();
  }

  handleMore() {
    const { entries, minTime } = this.state;
    const rest = entries.filter(entry => entry.timestamp < minTime);
    this.setState({
      minTime: rest.slice(0, PAGE_SIZE).slice(-1)[0].timestamp,
      more: rest.length > PAGE_SIZE,
    });
  }

  render() {
    const {
      entries, minTime, more, lastFetch, fetchError,
    } = this.state;
    return (
      <div className="liveblog">
        <div className="liveblog-lastfetch">
          { lastFetch && `Last updated at ${format(lastFetch, 'H:mm:ss')}` }
        </div>
        { fetchError && <div className="liveblog-error text-danger">{fetchError}</div> }
        <div className="liveblog-feed">
          { entries
            .filter(entry => !entry.type)
            .filter(entry => entry.timestamp >= minTime)
            .map(entry => <LiveBlogEntry key={entry.id} entry={entry} />) }
        </div>
        { more
          && <button className="liveblog-more" type="button" onClick={this.handleMore}>See older entries</button>
        }
      </div>
    );
  }
}

LiveBlog.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  pollInterval: PropTypes.number.isRequired,
};
